var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-user"},[_c('button-toolbar',{attrs:{"items":_vm.items,"status":_vm.status},on:{"add-item-click":_vm.handleAddItemClick,"search-input":_vm.handleSearchInput}}),_c('data-table',{staticStyle:{"margin-top":"25px"},attrs:{"profile":_vm.profile,"items":_vm.items,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }